module.exports = __webpack_public_path__ + "img/app-yjmh.449178f3.webp";